import { useMutation, useQuery } from 'react-query';
import {
  getFlexiPlanData,
  postFlexiPlanUpgrade,
  getPrices,
  postUpgrade,
} from 'services/payment/index';

export const useQueryGetPrices = () =>
  useQuery(
    'prices-metadata',
    async () => {
      const result = await getPrices();
      const data = result?.data ?? [];
      return data;
    },
    {
      retry: false,
      staleTime: 1000 * 60 * 60 * 24,
    },
  );

export const useMutationPostUpgrade = () =>
  useMutation('upgrade-metadata', async ({ plan }) => {
    const result = await postUpgrade(plan);
    const data = result?.data ?? [];
    return data;
  });

export const useQueryGetFlexiPlanData = () =>
  useQuery('flexi-plan-data', async () => {
    const result = await getFlexiPlanData();
    return result?.data ?? [];
  });

export const useMutationPostFlexiPlanUpgrade = () =>
  useMutation('upgrade-flexi-plan', async ({ planId, quantity }) => {
    const result = await postFlexiPlanUpgrade(planId, quantity);
    return result?.data ?? [];
  });
